import { forwardRef } from 'react';
import classnames from 'classnames';

import style from './collapsible-list.module.less';

import type { CollapsibleListProps } from './collapsible-list-types';

export const CollapsibleList = forwardRef<HTMLDivElement, CollapsibleListProps>(({ children, className = '', ...rest }, ref) => {
  return (
    <div ref={ref} className={classnames(style['collapsible-list'], className)} {...rest}>
      {children}
    </div>
  );
});
